module.exports = __webpack_public_path__ + "media/images/logos/c-map-md-1768044f4b9d376db751037c64ddaed9.png";